var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("td", { staticClass: "text-center td-items" }, [
    _vm.order.count_items
      ? _c(
          "a",
          {
            attrs: {
              href: "#",
              "data-toggle": "modal",
              "data-target": "#itemsModal"
            },
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.order.count_items) + " тов.")])]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dff80c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dff80c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/table/fields/ItemsField.vue
// module id = 182
// module chunks = 1